
import { useLocation } from "react-router-dom";

export interface PageInfo {
  parent: string | null;
  current: string;
}

export function usePageInfo(): PageInfo {
  const location = useLocation();
  const path = location.pathname;
  
  if (path === '/dashboard') return { parent: null, current: 'Dashboard' };
  if (path === '/cockpit') return { parent: 'Dashboard', current: 'Cockpit' };
  if (path === '/pagespeed') return { parent: 'Dashboard', current: 'PageSpeed' };
  if (path === '/workforce') return { parent: 'Dashboard', current: 'Workforce Planning' };
  if (path === '/teams') return { parent: null, current: 'Teams' };
  if (path.includes('/teams/') && path.includes('/projects')) return { parent: 'Teams', current: 'Projects' };
  
  return { parent: null, current: 'Page' };
}
